import UIDs from "../../../../../UIDs";

const uid = UIDs.screens.admin.section.edit;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    SAVE_SECTION_ASYNC: `${uid}.saveSectionAsync`,
    SAVE_SECTION_SUCCESS: `${uid}.saveSectionSuccess`,
    SAVE_SECTION_FAILURE: `${uid}.saveSectionFailure`,
    CREATE_SECTION: `${uid}.createSection`
};

export { ActionTypes };
